import React from "react";
import { Banner, ButtonSecondaryInverse, Text } from "../../../../components";
import backgroundImage from "../../../../assets/images/backgrounds/background-grid-secondary.jpg";
import { links } from "../../../../config";

const BannerHome = () => {
  return (
    <Banner
      smallerText="Encontre tudo sobre o nosso"
      sectionName="Banner Catalogo"
      variant="secondary"
      backgroundImage={backgroundImage}
    >
      <Text size="lg">
        Uma página para você, cliente, saber mais sobre seu título, sorteios e
        outras dúvidas.
      </Text>
      <ButtonSecondaryInverse
        href={links.areaLogada}
        label="Acesse a área do cliente"
      />
    </Banner>
  );
};

BannerHome.propTypes = {};

export default BannerHome;
